import { getPageOrderById, wechatWebPay, findPageOrderByMobile, getPageGoodByType, alipayOrderList, prepayAlipay, getAlipay, listDataAlipay } from '@/zsm-api-new/pay.js'
import { Message } from 'element-ui'
const state = {
  payModalWarnFlag:false
}

const mutations = {

}

const actions = {
  /**
 * 查询单笔订单
 * @param id 订单Id
*/
  getPageOrderById({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      getPageOrderById(id).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 微信web支付
   * @param goodId 商品Id
   * @param mobile 手机号
   */
  wechatWebPay({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      wechatWebPay(data).then(response => {
        if (response.result == 'false') {
          Message.error(response.message)

        } else {
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 讲师账单记录
   * @param {*} mobile 讲师账号
   * @param {*} id 订单号 
   * @returns 
   */
  findPageOrderByMobile({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      findPageOrderByMobile(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取讲师端支付商品列表
  getPageGoodByType({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getPageGoodByType().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取网站支付订单列表
  alipayOrderList({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      alipayOrderList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取需要支付的单个产品
  getAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      getAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取需要支付的商品列表
  listDataAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /** 
    * 网站支付宝支付
    * @param goodId 商品id
    * @param quantity 数量
    * @param receiverAddress 地址
    * @param receiverMobile 手机号
    * @param receiverName 收货人
    * @param returnUrl 回调地址
  */
  prepayAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      prepayAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 网站支付宝
  prepayAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      prepayAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取需要支付的商品列表
  listDataAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取需要支付的单个产品
  getAlipay({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      getAlipay(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取网站支付订单列表
  alipayOrderList({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      alipayOrderList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 创建订单
  createOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createOrder(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
